import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

type ApproveSuggestedContentVariables = {
	contentCalendarSuggestion: Api.ContentCalendarResourceToolCall;
	impersonationContext?: Api.IImpersonationContext;
	calendarId: string;
	suggestionIds?: string[];
};

export const useApproveSuggestedContentMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IContentCalendarSuggestion, variables: ApproveSuggestedContentVariables) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			contentCalendarSuggestion,
			calendarId,
			impersonationContext,
			suggestionIds,
		}: ApproveSuggestedContentVariables) => {
			return userSession.webServiceHelper.callAsync<Api.IContentCalendarSuggestion>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `ContentCalendarSuggestion/calendar/${calendarId}/confirm`,
					impersonationContext,
				}),
				'POST',
				{
					toolCall: {
						resourceType: 'ContentCalendar',
						resourceId: contentCalendarSuggestion.resourceId,
						id: contentCalendarSuggestion.id,
						toolName: 'lev-resource',
						_type: 'ResourceToolCall',
					},
					...(suggestionIds && suggestionIds.length > 0 ? { suggestionIds } : {}),
				}
			);
		},
		onError,
		onSuccess,
	});
};
